import React, { Component } from 'react';
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import { Row, Col, Card, CardHeader, Container } from "reactstrap";
import DnsProviderConfigForm from "../DnsProviderConfigForm/DnsProviderConfigForm";
import { createDnsProviderConfig } from '../../../actions/actionDnsProvider';
import { handleSaveSuccess, handleSaveError } from '../actions'


class CreateDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.submitApi = this.submitApi.bind(this);
        this.handleSaveSuccess = handleSaveSuccess.bind(this);
        this.handleSaveError = handleSaveError.bind(this);

    }

    componentDidMount(){
        this.props.getDnsProviderConfigs();
    }

    async submitApi() {
        try {
            await this.props.createDnsProviderConfig(this.props.providerValues)
            const provider = await this.handleSaveSuccess()
            this.props.savedProvider(provider)
        } catch (e) {
            this.handleSaveError()
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create DNS Provider Config</strong>
                                </CardHeader>
                                <DnsProviderConfigForm
                                    onSubmit={this.submitApi}
                                    createDnsProviderConfig={this.props.createDnsProviderConfig} />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
({
    dns_provider_configs: state.dns_provider.dns_provider_configs || [],
    saveDnsProviderError: state.dns_provider.saveDnsProviderError,
    saveDnsProviderLoading: state.dns_provider.saveDnsProviderLoading,
    savedDnsProvider: state.dns_provider.savedDnsProvider,
    providerValues: getFormValues('DnsProviderForm')(state),
}),
    dispatch =>
    ({
        createDnsProviderConfig: (data) => dispatch(createDnsProviderConfig(data))
    }))(CreateDnsProviderConfig);

